"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeadersPadrao = void 0;
const LOCALSTORAGE_KEYS = {
    AUTENTICACAO: 'tokenAutenticacao',
    SESSAO_E2E: 'e2eSessionId',
};
/**
 * Função responsável por gerar headers padrões da aplicação
 * **/
const getHeadersPadrao = (comAutenticacao = true, customHeaders = {}) => {
    const novosHeaders = Object.assign({ Accept: 'application/json', 'Accept-Language': 'pt-BR', 'X-Frame-Options': 'sameorigin', 'X-content-type-options': 'nosniff' }, customHeaders);
    const authToken = localStorage.getItem(LOCALSTORAGE_KEYS.AUTENTICACAO);
    if (comAutenticacao) {
        novosHeaders['Authorization'] = `Bearer ${authToken}`;
    }
    const e2eSessionId = localStorage.getItem(LOCALSTORAGE_KEYS.SESSAO_E2E);
    if (e2eSessionId) {
        novosHeaders['e2eSessionId'] = e2eSessionId;
    }
    return novosHeaders;
};
exports.getHeadersPadrao = getHeadersPadrao;
//# sourceMappingURL=headers.js.map